/*
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React, {ChangeEvent, useState} from 'react';
import {makeStyles, Tooltip} from '@material-ui/core';
import {translate} from '@ion/core/src/locale/locale';
import Switch from '@ion/dls/src/components/switch/Switch';
import {dlsColor} from '@ion/dls/src/theme/theme';
import {BodyTypography} from '@ion/dls/src/typography/BodyTypography';
import TopNavHelpIcon from '../icons/TopNavHelpIcon';
import {toggleTooltip} from './UserPreferencesEditor';

// defines the prop definitions for DefaultViewSubaccountToggle...
export interface DefaultViewSubaccountToggleProps {
  onChange?: Function;
  includeSubAccToggleSetup?: boolean;
};

const useStyles = makeStyles(theme => ({
  defaultTogglePanel : {
    display         : 'flex',
    justifyContent  : 'space-between',
    backgroundColor : dlsColor('white'),
    padding         : 10,
    alignItems      : 'center'
  },
  preferencesTitle : {
    color : dlsColor('grey1')
  },
  prefernecesTooltip : {
    display    : 'flex',
    alignItems : 'center',
    marginLeft : '6px'
  }
}));

/**
 * Allows user to choose a Default View Subaccount option.
 *
 * ```typescript
 * import {DefaultViewSubaccountToggle} from '@ion/dls/src/editors/DefaultViewSubaccountToggle';
 *
 * <DefaultViewSubaccountToggle 
 * onChange={handleChange} />
 *
 * ```
 */
export const DefaultViewSubaccountToggle = ({
  onChange,
  includeSubAccToggleSetup = false
}: DefaultViewSubaccountToggleProps) => {
  const classes                                                 = useStyles();
  const [includeSubAccountSetting, setIncludeSubAccountSetting] = useState<boolean>(includeSubAccToggleSetup);
  const path                                                    = 'common:editors.preferences';
  
  const handleChange = function({target:{checked}}: ChangeEvent<HTMLInputElement>) {
    setIncludeSubAccountSetting(checked);
    onChange(checked);
  };

  const ToggleTooltip = function(props) {
    return <Tooltip arrow classes={toggleTooltip()} {...props} />;
  };

  return (
    <div>
      <div className={classes.defaultTogglePanel}>
        <div style={{display: 'flex'}}>
          <BodyTypography className={classes.preferencesTitle}>
            {translate(`${path}.defaultViewSubaccount`)}
          </BodyTypography>
          <ToggleTooltip title={translate(`${path}.defaultViewSubaccountTooltip`)}>
            <div className={classes.prefernecesTooltip}>
              <TopNavHelpIcon/>
            </div>
          </ToggleTooltip>
        </div>
        <Switch disabled={false}
          onChange={handleChange}
          checked={includeSubAccountSetting} />
      </div>
    </div>
  );
};

export default DefaultViewSubaccountToggle;
